<template>
  <div class="content_div">
    <el-card>
      <!-- 搜索区域 -->
      <el-form :inline="true" :model="query" class="demo-form-inline" style="margin-bottom: 20px;">
        <el-form-item label="商品名称">
          <el-input clearable class="input_class" v-model="query.goodsName" auto-complete="off" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="商品分类">
          <el-select v-model="query.categoryId" placeholder="请选择分类" clearable>
            <el-option label="全部分类" value="" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="请选择状态" clearable>
            <el-option label="上架" :value="1" />
            <el-option label="下架" :value="0" />
          </el-select>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
        <el-button type="success" @click="btnInsert()">新增</el-button>
      </el-form>

      <el-table
        :data="dataList"
        border>
        <el-table-column type="index" label="编号" width="80"/>
        <el-table-column prop="goodsName" label="商品名称" show-overflow-tooltip/>
        <el-table-column prop="goodsImage" label="商品图片" width="100">
          <template slot-scope="scope">
            <el-image v-if="scope.row.goodsImage" :src="scope.row.goodsImage" style="width: 50px; height: 50px" fit="cover" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格" width="100"/>
        <el-table-column prop="stock" label="库存" width="100"/>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
              {{ scope.row.status === 1 ? '上架' : '下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80"/>
        <el-table-column prop="createTime" label="创建时间" width="180"/>
        <el-table-column align="center" label="操作" width="210">
          <template slot-scope="scope">
            <el-button size="small" type="info" @click="btnUpdate(scope.row)">修改</el-button>
            <el-button size="small" type="danger" @click="btnDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <el-pagination style="margin-top:10px;"
                     background
                     layout="total,prev, pager, next"
                     @current-change="currentChange"
                     :current-page="query.currentPage"
                     :page-size="query.pageSize"
                     :total="total">
      </el-pagination>
    </el-card>

    <!-- 新增/编辑对话框（带SKU管理） -->
    <el-dialog :close-on-click-modal="false" title="商品管理" :visible="isShowDialogFlag" @close="close" width="80%" top="5vh">
      <el-form label-width="120px" :model="data" ref="data" :rules="rules">
        <el-divider content-position="left">基本信息</el-divider>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商品名称" prop="goodsName">
              <el-input v-model="data.goodsName" maxlength="50" auto-complete="off" placeholder="请输入商品名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品分类" prop="categoryId">
              <el-select v-model="data.categoryId" placeholder="请选择分类" style="width: 100%;">
                <el-option v-for="item in categoryList" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商品价格" prop="price">
              <el-input-number v-model="data.price" :min="0" :precision="2" controls-position="right" style="width: 100%;"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="库存" prop="stock">
              <el-input-number v-model="data.stock" :min="0" controls-position="right" style="width: 100%;"/>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="商品图片" prop="goodsImage">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :auto-upload="false">
            <img v-if="data.goodsImage" :src="data.goodsImage" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="商品介绍" prop="introduction">
          <el-input type="textarea" v-model="data.introduction" maxlength="500" :rows="3" placeholder="请输入商品介绍"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="data.status">
                <el-radio :label="1">上架</el-radio>
                <el-radio :label="0">下架</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              <el-input-number v-model="data.sort" :min="0" controls-position="right" style="width: 100%;"/>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">SKU规格管理</el-divider>
        
        <el-form-item label="启用多规格">
          <el-switch v-model="enableSku" active-text="开启" inactive-text="关闭"></el-switch>
        </el-form-item>

        <!-- SKU表格 -->
        <div v-if="enableSku" class="sku-container">
          <el-button type="primary" size="small" @click="addSkuRow" style="margin-bottom: 10px;">添加规格</el-button>
          
          <el-table :data="skuList" border size="small">
            <el-table-column label="规格名称" width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.specName" placeholder="如：颜色、尺寸" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="规格值" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.specValue" placeholder="如：红色、XL" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="价格" width="120">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.price" :min="0" :precision="2" size="small" controls-position="right"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="库存" width="120">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.stock" :min="0" size="small" controls-position="right"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="SKU编码" width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.skuCode" placeholder="可选" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="removeSkuRow(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click='close'>取消</el-button>
        <el-button type="primary" class="title" @click="submitForm('data')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGoodsPage, insertGoods, updateGoods, deleteGoods } from '@/api/ordering/goods'
import { listEnabledCategories } from '@/api/ordering/category'
import { batchInsertSkus, deleteSkusByGoodsId } from '@/api/ordering/sku'

export default {
  name: 'GoodsListWithSku',
  async created() {
    await this.load()
    await this.loadCategories()
  },
  data() {
    return {
      total: 0,
      dataList: [],
      categoryList: [],
      query: {
        currentPage: 1,
        pageSize: 10,
        goodsName: undefined,
        categoryId: undefined,
        status: undefined
      },
      isShowDialogFlag: false,
      enableSku: false,
      skuList: [],
      data: {
        id: null,
        goodsName: null,
        categoryId: null,
        price: 0,
        stock: 0,
        goodsImage: null,
        introduction: null,
        status: 1,
        sort: 1
      },
      rules: {
        goodsName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '请选择商品分类', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入商品价格', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async load() {
      this.dataList = []
      let res = await getGoodsPage(this.query)
      this.dataList = res.records || []
      this.total = res.total || 0
    },
    async loadCategories() {
      let res = await listEnabledCategories()
      this.categoryList = res || []
    },
    currentChange(num) {
      this.query.currentPage = num
      this.load()
    },
    btnInsert() {
      this.resetFormData()
      this.enableSku = false
      this.skuList = []
      this.isShowDialogFlag = true
    },
    btnUpdate(row) {
      this.data = JSON.parse(JSON.stringify(row))
      this.enableSku = false
      this.skuList = []
      this.isShowDialogFlag = true
    },
    resetFormData() {
      this.data = {
        id: null,
        goodsName: null,
        categoryId: null,
        price: 0,
        stock: 0,
        goodsImage: null,
        introduction: null,
        status: 1,
        sort: 1
      }
    },
    addSkuRow() {
      this.skuList.push({
        specName: '',
        specValue: '',
        price: 0,
        stock: 0,
        skuCode: ''
      })
    },
    removeSkuRow(index) {
      this.skuList.splice(index, 1)
    },
    async close() {
      this.isShowDialogFlag = false
      if (this.$refs.data) {
        this.$refs.data.clearValidate()
      }
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            // 保存商品
            let result = !this.data.id ? await insertGoods(this.data) : await updateGoods(this.data)
            
            // 如果启用了SKU，保存SKU信息
            if (this.enableSku && this.skuList.length > 0 && this.data.id) {
              // 先删除旧的SKU
              await deleteSkusByGoodsId(this.data.id)
              
              // 批量插入新的SKU
              const skuDataList = this.skuList.map(sku => ({
                goodsId: this.data.id,
                specName: sku.specName,
                specValue: sku.specValue,
                price: sku.price,
                stock: sku.stock,
                skuCode: sku.skuCode
              }))
              await batchInsertSkus(skuDataList)
            }
            
            this.$message.success('操作成功')
            await this.close()
            await this.load()
          } catch (error) {
            this.$message.error('操作失败：' + (error.message || '未知错误'))
          }
        }
      })
    },
    async btnDelete(id) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteGoods(id)
        this.$message.success('操作成功')
        this.query.currentPage = 1
        await this.load()
      })
    }
  }
}
</script>

<style scoped>
.content_div {
  padding: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.sku-container {
  margin-top: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}
</style>
